module.exports = __webpack_public_path__ + "img/poster_2.db945480.png";